import { httpClient } from '@/shared/services/HttpClient';
import { CancelToken } from 'axios';
import qs from 'qs';

class AdFilterService {
  url = 'operation/estate-filter';

  get(params: any, cancelToken?: CancelToken): any {
    const qsString = qs.stringify(params, { skipNulls: true, encodeValuesOnly: true });
    return httpClient.get(this.url + '?' + qsString, { cancelToken });
  }

  insert(data: any): any {
    return httpClient.post(this.url, data);
  }

  update(data: any): any {
    return httpClient.put(this.url, data);
  }

  delete(adFilterId: string): any {
    return httpClient.delete(this.url + '/' + adFilterId);
  }
}

const adFilterService = new AdFilterService();

export { adFilterService };
